// @flow
import React from 'react'
import styled from 'styled-components'

type Props = {
  component: {gridName:string, id:string|null} | null,
  wasRemoved: boolean,
  onClick: (comp:{gridName:string, id:string|null}) => void,
  active: boolean
}

export default function GridArea (props:Props) {
  let {component, wasRemoved, active} = props
  if(!component) return null
  return (
    <Wrapper wasRemoved={wasRemoved} onClick={() => props.onClick(component)} active={active}>
      {component.gridName}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${props => props.wasRemoved ? '#e91e63' : '#c3cfd5'};
  border-left: 5px solid ${props => props.active ? 'green' : 'transparent'};
  border-radius: 2px;
`


// WEBPACK FOOTER //
// ./src/components/GridArea.js